import { isTileVerticallyVisible } from './is-tile-visible';

export const makeOnlyVisibleTilesClickable = (colorImageTileContainer: HTMLElement) => {
    colorImageTileContainer.querySelectorAll<HTMLElement>('.js_pdp_dimension-selection__color-tile').forEach(tileElement => {
        if (!isTileVerticallyVisible(colorImageTileContainer, tileElement)) {
            tileElement.style.pointerEvents = 'none';
        } else {
            tileElement.style.pointerEvents = 'auto';
        }
    });
};
